"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppDBCollectionPermission = void 0;
var AppDBCollectionPermission;
(function (AppDBCollectionPermission) {
    AppDBCollectionPermission["Admin"] = "ADMIN";
    AppDBCollectionPermission["Write"] = "WRITE";
    AppDBCollectionPermission["Read"] = "READ";
    AppDBCollectionPermission["share"] = "SHARE";
    AppDBCollectionPermission["Delete"] = "DELETE";
    AppDBCollectionPermission["CreateContent"] = "CREATE_CONTENT";
    AppDBCollectionPermission["UpdateContent"] = "UPDATE_CONTENT";
    AppDBCollectionPermission["ReadContent"] = "READ_CONTENT";
    AppDBCollectionPermission["DeleteContent"] = "DELETE_CONTENT";
})(AppDBCollectionPermission = exports.AppDBCollectionPermission || (exports.AppDBCollectionPermission = {}));
